import * as React from "react";

/**
 * @returns the initial value even if it changes on subsequent renders.
 */
export function useInitial<ValueType>(value: ValueType) {
  return React.useRef(value).current;
}
